import React from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Tabs,
  Tab,
  Modal,
} from "react-bootstrap";
import {
  getAllSubscriptionAction,
  getSubscriptionDetail,
} from "./../../../actions/SubscriptionAction";
import {
  getProrationAction,
  changeSubscriptionAction,
} from "./../../../actions/ChangePlanActions";
import * as code from "./../../../config/Constants";
import { connect } from "react-redux";
import { currencyFormat, toastMessage } from "./../../Common/Common";

class ChangePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthData: [],
      yearData: [],
      showLoader: false,
      prorationModal: false,
      prorationData: [],
      newPriceId: "",
      accountInfo: "",
    };
  }

  componentWillMount() {
    this.setState({ showLoader: true });
    // this.props.getAllSubscriptionAction("month").then(monthRes => {
    //     this.setState({ showLoader: false });
    //     if (monthRes.status === code.OK) {
    //         this.setState({ monthData: monthRes.data });
    //     }
    // });
    // this.props.getAllSubscriptionAction("year").then(yearRes => {
    //     this.setState({ showLoader: false });
    //     if (yearRes.status === code.OK) {
    //         this.setState({ yearData: yearRes.data });
    //     }
    // });
    this.getSubscriptionDetail();
  }
  getSubscriptionDetail() {
    this.setState({ showLoader: true });
    this.props.getSubscriptionDetail().then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        this.setState({ accountInfo: res.data });
      }
    });
  }
  /**
   * @desc get proration data as per plan selection
   * @param newPriceId
   */
  getProrationData(newPriceId) {
    this.props.getProrationAction(newPriceId).then((proData) => {
      this.setState({ newPriceId });

      if (proData.status === code.OK) {
        this.setState({ prorationModal: true, prorationData: proData.data });
      }
    });
  }
  setProrationModal() {
    this.setState({ prorationModal: !this.state.prorationModal });
  }
  /**
   * @desc upgrade/downgrade plan
   */
  changePlan() {
    let data = {
      newPriceId: this.state.newPriceId,
      prorationDate: this.state.prorationData[2],
      billingCycleAnchor: this.state.prorationData[3],
    };
    this.props.changeSubscriptionAction(data).then((res) => {
      if (res.status === code.OK) {
        this.setProrationModal();
        localStorage.setItem(
          "priceId",
          !!res.data.subsriptionDetails
            ? res.data.subsriptionDetails.priceId
            : ""
        );
        toastMessage(code.SUCCESS, "Plan changed successfully");
        this.props.history.push("/Subscription/SubscriptionDetail");
      }
    });
  }
  render() {
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <Row className="mx-0 page-head-row page-head-row-big align-items-center">
              <Col>
                <h4 className="title-med mt-0 pt-1">Change Plan</h4>
              </Col>
            </Row>
            <div className="container-custom pricing">
              <Row className="mt-5">
                <Col
                  md={{ span: 6, offset: 3 }}
                  className="current-subscription-plan"
                >
                  <h5>Current Plan</h5>
                  <ul>
                    <li>
                      <label>Plan: </label>
                      <span>
                        {!!this.state.accountInfo.subscriptionSummary
                          ? this.state.accountInfo.subscriptionSummary
                              .productName
                          : ""}
                      </span>
                    </li>
                    <li>
                      <label>Status: </label>
                      <span>
                        {!!this.state.accountInfo.subscriptionSummary
                          ? this.state.accountInfo.subscriptionSummary.status.toUpperCase()
                          : ""}
                      </span>
                    </li>
                    <li>
                      <label>Price: </label>
                      <span>
                        {!!this.state.accountInfo.subscriptionSummary
                          ? !this.state.accountInfo.subscriptionSummary
                              .isCancelAtPeriodEnd &&
                            localStorage.getItem("isActive") === "true"
                            ? currencyFormat(
                                this.state.accountInfo.subscriptionSummary
                                  .nextInvoiceAmount / 100
                              )
                            : "-"
                          : ""}
                      </span>
                    </li>
                    <li>
                      <label>Payment Due: </label>
                      <span>
                        {!!this.state.accountInfo.subscriptionSummary
                          ? !this.state.accountInfo.subscriptionSummary
                              .isCancelAtPeriodEnd &&
                            localStorage.getItem("isActive") === "true"
                            ? this.state.accountInfo.subscriptionSummary
                                .nextInvoiceDate
                            : "-"
                          : ""}
                      </span>
                    </li>
                  </ul>
                </Col>
              </Row>
              <Tabs
                defaultActiveKey="monthly"
                id="uncontrolled-tab-example"
                className="subscription-tabs"
              >
                <Tab eventKey="monthly" title="Monthly">
                  <Row>
                    {this.state.monthData.map((monthData) => {
                      //show data if product and price both are active
                      if (monthData.price.isActive && monthData.isActive) {
                        let description =
                          "<div>" + monthData.description + "</div>";

                        return (
                          <Col
                            lg={3}
                            md={6}
                            sm={6}
                            className={`plan-scheme ${
                              localStorage.getItem("priceId") ===
                              monthData.price.price
                                ? "active-plan"
                                : ""
                            }`}
                          >
                            <Card className="transaction-single">
                              <Card.Body>
                                <h4>{monthData.name}</h4>
                                <p className="plan-price">
                                  {currencyFormat(monthData.price.unit_amount)}
                                  /mo.
                                </p>
                                <div className="plan-desc">
                                  <label>Description</label>
                                  <p
                                    className="plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: monthData.description,
                                    }}
                                  />
                                  <div
                                    className="more-plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                </div>
                                <Button
                                  variant="primary"
                                  className="btn-blue w-140"
                                  onClick={() =>
                                    this.getProrationData(monthData.price.price)
                                  }
                                  disabled={
                                    localStorage.getItem("priceId") ===
                                    monthData.price.price
                                      ? true
                                      : false
                                  }
                                >
                                  {localStorage.getItem("priceId") ===
                                  monthData.price.price
                                    ? "CURRENT PLAN"
                                    : "SELECT PLAN"}
                                </Button>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      }
                    })}
                  </Row>
                </Tab>
                <Tab eventKey="annually" title="Annually">
                  <Row>
                    {this.state.yearData.map((yearData) => {
                      if (yearData.price.isActive && yearData.isActive) {
                        let description =
                          "<div>" + yearData.description + "</div>";

                        return (
                          <Col
                            lg={3}
                            md={6}
                            sm={6}
                            className={`plan-scheme ${
                              localStorage.getItem("priceId") ===
                              yearData.price.price
                                ? "active-plan"
                                : ""
                            }`}
                          >
                            <Card className="transaction-single">
                              <Card.Body>
                                <h4>{yearData.name}</h4>
                                <p className="plan-price">
                                  {currencyFormat(yearData.price.unit_amount)}
                                  /yr.
                                </p>
                                <div className="plan-desc">
                                  <label>Description</label>
                                  <p
                                    className="plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: yearData.description,
                                    }}
                                  />
                                  <div
                                    className="more-plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                </div>

                                <Button
                                  variant="primary"
                                  className="btn-blue w-140"
                                  onClick={() =>
                                    this.getProrationData(yearData.price.price)
                                  }
                                  disabled={
                                    localStorage.getItem("priceId") ===
                                    yearData.price.price
                                      ? true
                                      : false
                                  }
                                >
                                  {localStorage.getItem("priceId") ===
                                  yearData.price.price
                                    ? "CURRENT PLAN"
                                    : "SELECT PLAN"}
                                </Button>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      }
                    })}
                  </Row>
                </Tab>
              </Tabs>
            </div>
            <Modal
              show={this.state.prorationModal}
              onHide={() => this.setProrationModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med1 add-payment-method"
              centered
            >
              <Form className="form-sm form-admin">
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Upgrade Subscription Plan
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>{this.state.prorationData[0]}</p>
                  <p>{this.state.prorationData[1]}</p>
                </Modal.Body>
                <Modal.Footer className="modal-footer-btn-center">
                  <Button
                    variant="primary"
                    className="btn-blue btn-outlined w-140"
                    onClick={() => {
                      this.setProrationModal();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    className="btn-blue w-140"
                    onClick={() => {
                      this.changePlan();
                    }}
                  >
                    Change Plan
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    proration: state.reducer.proration,
  };
};
export default connect(
  mapStateToProps,
  {
    getAllSubscriptionAction,
    getProrationAction,
    changeSubscriptionAction,
    getSubscriptionDetail,
  }
)(ChangePlan);
